import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Node3D } from '../../../base/node3d/Component';
import { PluginGizmo } from '../../../../r3f/gizmo/PluginGizmo';
import { WheelGizmo } from './WheelGizmo';
import { VEHICLE_WHEEL_3D_DEFAULTS as DEFAULTS } from './types';
export function VehicleWheel3D({ node, children }) {
    const props = node.properties;
    return (_jsxs(Node3D, { node: node, children: [_jsx(PluginGizmo, { drawnFor: "every-node", children: _jsx(WheelGizmo, { radius: props.wheel_radius ?? DEFAULTS.wheel_radius, restLength: props.wheel_rest_length ?? DEFAULTS.wheel_rest_length }) }), children] }));
}
//# sourceMappingURL=Component.js.map